import { useEffect, useRef, useState } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { motion } from 'framer-motion';
import { assets } from '@/lib/assets';
import { cn } from '@/lib/utils/cn';

export const Diamond = ({
  value,
  className,
  ...others
}: { value: number } & React.HTMLAttributes<HTMLDivElement>) => {
  const [diamonds, setDiamonds] = useState(0);
  const [animVisible, setAnimVisible] = useState(false);
  const [textSize, setTextSize] = useState('1rem');
  const diamondRef = useRef<HTMLDivElement>(null);

  const animateScore = () => {
    setAnimVisible(true);
    setTimeout(() => {
      setAnimVisible(false);
    }, 2000);
  };

  // each time items founds change, we display a super anim! youpee
  useEffect(() => {
    if (diamonds !== value) {
      setDiamonds(value);
      animateScore();
    }
  }, [value]);

  // on mount, e update the text size
  useEffect(() => {
    const updateTextSize = () => {
      if (diamondRef.current) {
        const diamondHeight = diamondRef.current.clientHeight;
        const fontSize = diamondHeight * 0.6;
        setTextSize(`${fontSize}px`);
      }
    };
    // Calculate size when component mounts
    updateTextSize();
  }, []);

  return (
    <div {...others} className={cn('relative', className)}>
      <div className="relative flex h-full w-full items-center justify-center">
        <motion.div
          ref={diamondRef}
          className={cn(
            'relative h-full',
            animVisible && 'drop-shadow-[0px_0px_20px_rgba(255,255,255,0.8)]'
          )}
          initial="normal"
          whileHover="hover"
          animate={animVisible ? 'animated' : 'normal'}
          variants={{
            normal: { scale: 1, filter: '' },
            hover: { scale: 1.1 },
            animated: {
              scale: 1.2,
              // filter: 'drop-shadow(0px 0px 20px rgba(255,255,255,0.8))',
              transition: { duration: 0.5, ease: 'backInOut' },
            },
          }}
        >
          <img
            src={assets.common.diamond}
            alt="diamond"
            className="relative h-full"
          />

          <div className="absolute left-0 top-0 flex h-3/4 w-full items-center justify-center font-bold drop-shadow-[0px_1px_2px_rgba(0,0,0,1)]">
            <span className="relative" style={{ fontSize: textSize }}>
              {value}
            </span>
          </div>
          {/** effect */}
          {animVisible && (
            <DotLottieReact
              className="absolute top-0 h-full w-full scale-150"
              src="https://lottie.host/6cc61c45-27b7-446e-b3c5-e400f92cf22e/TBhREGw0oo.lottie"
              autoplay
              onCompositionEnd={() => setAnimVisible(false)}
            />
          )}
        </motion.div>
      </div>
    </div>
  );
};
